<p-dialog header="Load Saved Search" [(visible)]="loadSearchVisible" [modal]="true" [closable]="false"
    [style]="{width:'50vw'}">
    <div class="p-field">
        <label class="mb-3 h6" for="saveSearchName">Select File to Load</label>
        <p>Select a saved search file then click "Load Search" to execute the search.</p>
        <p><i>NOTE: the file must be a '.txt' file, such as the one that was saved originally.</i></p>
        <p-fileUpload #fileUpload name="file-upload" [maxFileSize]="1000000" [multiple]="false" chooseLabel="Choose File"
         (onSelect)="onFileSelect($event);" (onRemove)="onClearFile($event)" uploadLabel="Search" [auto]="true"
        ></p-fileUpload>
        <small *ngIf="loadError" class="text-danger"><i class="pi pi-close"></i> There was an error loading the file.</small>
    </div>
    <div class="float-end">
        <button p-button class="btn btn-primary mt-3 mb-3 me-3" (click)="executeClose()"><span class="fas fa-circle-xmark"></span>
            Close
        </button>
        <button p-button class="btn btn-secondary mt-3 mb-3" (click)="executeLoadSearch()"> <span
                class="pi pi-upload"></span> Load
            Search</button>
    </div>
</p-dialog>
<p-toast key="loadSearch"></p-toast>